import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Customer } from '../model/customer';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomercreateService {

  constructor(private http:HttpClient) { }

  getCustomers(pit:String){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/list/pit/'+pit,httpOptions)
      .pipe(map((res) => Array.isArray(res) ? res : (res?.Items || [])));
  }
  
  createCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer',JSON.stringify(customer),httpOptions);
  }
  updateCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customer.customerId,JSON.stringify(customer),httpOptions)
  }
  deleteCustomer(customer:Customer){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customer.customerId,httpOptions)
  }
}
